import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@pitchero/react-ui';
import TokenRedirect from '../../token-redirect-link/route';

const MessagesLink = ({ children }) => (
  <TokenRedirect route="account.messages">
    <Typography preset="description" color="primary" weight="bold">
      {children}
    </Typography>
  </TokenRedirect>
);

MessagesLink.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape()),
};

MessagesLink.defaultProps = {
  children: [],
};

export default MessagesLink;
